import { render, staticRenderFns } from "./onSubFormRowInsert-editor.vue?vue&type=template&id=ae0fbd12&scoped=true&"
import script from "./onSubFormRowInsert-editor.vue?vue&type=script&lang=js&"
export * from "./onSubFormRowInsert-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0fbd12",
  null
  
)

export default component.exports